import { SUPABASE_URL, getDbHeaders, supabaseClient } from "./client";

// Write a self-service password change to the audit log.
// Uses the user's own JWT so it works with RLS.
export async function dbLogSelfPasswordChange(sccoName) {
  const { error } = await supabaseClient
    .from("admin_audit_log")
    .insert({ actor_name: sccoName || "unknown", action: "self_password_change", target: "self" });
  if (error) console.warn("[audit] self_password_change log failed:", error.message);
}

export async function dbUpdateSccoPassword(sccoId, password) {
  await fetch(SUPABASE_URL + "/functions/v1/admin-update-auth", {
    method: "POST",
    headers: await getDbHeaders(),
    body: JSON.stringify({ action: "update_scco_password", scco_id: sccoId, password }),
  }).catch(e => console.warn("[Auth] SCCO auth sync failed:", e));
}

export async function dbUpdateAirlinePassword(code, password) {
  await fetch(SUPABASE_URL + "/functions/v1/admin-update-auth", {
    method: "POST",
    headers: await getDbHeaders(),
    body: JSON.stringify({ action: "update_password", code, password }),
  }).catch(e => console.warn("[Auth] Airline auth sync failed:", e));
}

export async function dbSetSccoAdmin(sccoId, isAdmin) {
  // Update the scco table record
  await fetch(SUPABASE_URL + "/rest/v1/scco?id=eq." + sccoId, {
    method: "PATCH",
    headers: await getDbHeaders(),
    body: JSON.stringify({ is_admin: isAdmin }),
  });
  // Sync is_admin into Supabase Auth user_metadata so JWT claims update on next login
  await fetch(SUPABASE_URL + "/functions/v1/admin-update-auth", {
    method: "POST",
    headers: await getDbHeaders(),
    body: JSON.stringify({ action: "update_scco_is_admin", scco_id: sccoId, is_admin: isAdmin }),
  }).catch(e => console.warn("[Auth] SCCO admin sync failed:", e));
}
